import React from 'react';
import { COMPANY } from '../mock/data';
import { Reveal } from '../hooks/useReveal';
import SEO, { breadcrumbLd } from '../components/SEO';

const DatenschutzPage = () => {
  return (
    <div className="bg-white pt-32 pb-24">
      <SEO
        title="Datenschutzerklärung · Frachigers Handwerk"
        description="Datenschutzerklärung von Frachigers Handwerk gemäss Schweizer DSG und EU-DSGVO. Informationen zur Verarbeitung Ihrer Daten."
        path="/datenschutz"
        jsonLd={[breadcrumbLd([{ name: 'Home', path: '/' }, { name: 'Datenschutz', path: '/datenschutz' }])]}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-brand-blueLight uppercase tracking-[0.3em] text-xs mb-3 font-bold">Rechtliches</div>
          <h1 className="font-display text-5xl md:text-6xl text-brand-blueDark leading-tight mb-10 tracking-tight">Datenschutzerklärung</h1>
        </Reveal>

        <div className="space-y-8 text-brand-ink/85 leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">1. Verantwortliche Stelle</h2>
            <p>Verantwortlich für die Datenverarbeitung im Sinne des schweizerischen Datenschutzgesetzes (DSG) sowie der EU-Datenschutz-Grundverordnung (DSGVO):</p>
            <p className="mt-2"><strong>Frachigers Handwerk – Armin Achermann</strong><br />
              Steckenmattstrasse 11, 6377 Seelisberg, Schweiz<br />
              Telefon: <a href={`tel:${COMPANY.phoneInternational}`} className="text-brand-blue">{COMPANY.phone}</a><br />
              E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-brand-blue">{COMPANY.email}</a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">2. Grundsätze</h2>
            <p>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und halten uns strikt an die Regeln der Datenschutzgesetze. Personenbezogene Daten werden auf dieser Website nur im technisch notwendigen Umfang erhoben. In keinem Fall werden die erhobenen Daten verkauft oder aus anderen Gründen an Dritte weitergegeben.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">3. Kontaktformular</h2>
            <p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.</p>
            <p className="mt-2">Für den Versand der E-Mails nutzen wir den Dienst <strong>Resend</strong> (Resend, Inc., USA). Dabei werden Ihre Formulardaten (Name, E-Mail, Telefonnummer, Adresse, Nachricht) sicher über HTTPS an die Server von Resend übermittelt. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. berechtigtes Interesse an einer effizienten Bearbeitung.</p>
            <p className="mt-2">Die Daten werden zur Bearbeitung Ihrer Anfrage sowie zur Erfüllung gesetzlicher Aufbewahrungspflichten gespeichert und nach Erledigung Ihres Anliegens gelöscht, sofern keine gesetzlichen Aufbewahrungsfristen entgegenstehen.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">4. Server-Log-Dateien</h2>
            <p>Der Provider dieser Website erhebt und speichert automatisch Informationen in Server-Log-Dateien, die Ihr Browser automatisch übermittelt (Browsertyp, Betriebssystem, Referrer-URL, Hostname, Uhrzeit, IP-Adresse). Diese Daten sind nicht bestimmten Personen zuordenbar und werden nicht mit anderen Datenquellen zusammengeführt.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">5. Cookies</h2>
            <p>Unsere Website verwendet ausschliesslich technisch notwendige Cookies (z. B. zur Speicherung Ihrer Sprachwahl und Ihrer Cookie-Einwilligung). Es werden keine Tracking-, Marketing- oder Analyse-Cookies eingesetzt. Sie können in Ihren Browsereinstellungen jederzeit Cookies löschen.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">6. Google Maps</h2>
            <p>Auf der Kontaktseite binden wir eine Karte von Google Maps ein. Anbieter ist Google Ireland Limited, Irland. Beim Aufruf der Kontaktseite wird eine Verbindung zu Servern von Google hergestellt, wobei Ihre IP-Adresse an Google übertragen wird. Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-brand-blue">policies.google.com/privacy</a>.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">7. Instagram</h2>
            <p>Wir verlinken auf unser Instagram-Profil (@lamurista.ch). Beim Klick auf einen Instagram-Link verlassen Sie unsere Website. Es gelten die Datenschutzbestimmungen von Meta Platforms Ireland Ltd.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">8. Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Wenden Sie sich hierzu jederzeit an uns unter <a href={`mailto:${COMPANY.email}`} className="text-brand-blue">{COMPANY.email}</a>.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">9. SSL-Verschlüsselung</h2>
            <p>Diese Website nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an dem <code>https://</code> in der Adresszeile Ihres Browsers.</p>
          </section>

          <p className="text-xs text-brand-ink/50 pt-4">Stand: {new Date().toLocaleDateString('de-CH', { year: 'numeric', month: 'long' })}</p>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
